import * as types from '../api/types';

export function jobStatusLabel(value: string): string {
  return value.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function jobNextStatuses(job: types.Job): types.JobStatus[] {
  const transitions: Record<string, types.JobStatus[]> = {
    DRAFT: [types.JobStatus.WORK_ORDER_GENERATED, types.JobStatus.SCHEDULED, types.JobStatus.CANCELLED],
    WORK_ORDER_GENERATED: [types.JobStatus.SCHEDULED, types.JobStatus.IN_PROGRESS, types.JobStatus.COMPLETED, types.JobStatus.CANCELLED],
    SCHEDULED: [types.JobStatus.WORK_ORDER_GENERATED, types.JobStatus.IN_PROGRESS, types.JobStatus.COMPLETED, types.JobStatus.CANCELLED],
    IN_PROGRESS: [types.JobStatus.COMPLETED, types.JobStatus.CANCELLED],
  };
  return (transitions[job.status] || []).filter((status) => status !== types.JobStatus.SCHEDULED || Boolean(job.scheduledDate));
}
